import React from 'react';
import { motion } from 'framer-motion';

interface PriceCardProps {
  title: string;
  price: string;
  highlight?: boolean;
}

const PriceCard: React.FC<PriceCardProps> = ({ title, price, highlight = false }) => {
  return (
    <motion.div
      whileHover={{ y: -8, scale: 1.02 }}
      transition={{ duration: 0.3 }}
      className={`relative p-4 md:p-6 lg:p-8 transition-all duration-500 overflow-hidden ${
        highlight 
          ? 'luxury-card bg-white text-gray-800 border-2 border-koi-red' 
          : 'luxury-card hover:border-koi-red/40'
      }`}
    >
      {highlight && (
        <div className="absolute top-0 right-0 w-32 h-32 bg-koi-red/10 rounded-full -mr-16 -mt-16" />
      )}
      
      <div className="relative z-10">
        <h3 className={`text-sm md:text-base lg:text-lg font-body tracking-wide mb-2 md:mb-3 lg:mb-4 ${
          highlight ? 'text-gray-800' : 'text-gray-700'
        }`}>
          {title}
        </h3>
        
        <div className="flex items-baseline gap-1">
          <span className={`text-sm ${highlight ? 'text-koi-red' : 'text-gray-600'}`}>€</span>
          <p className={`text-2xl md:text-3xl lg:text-4xl font-display ${
            highlight ? 'text-koi-red' : 'text-gray-800'
          }`}>
            {price.replace('€', '')}
          </p>
        </div>

        {highlight && (
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: '50px' }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="h-px bg-koi-red mt-4"
          />
        )}
      </div>
    </motion.div>
  );
};

export default PriceCard;